const KeenSlider = window.KeenSlider

const { setInitialised, useArrows } = window.BAO.Carousel.plugins

export class ProductModal extends window.BAO.CustomElement({
  SuperClass: HTMLDialogElement,
}) {
  connectedCallback () {
    super.connectedCallback()

    this.handleTrigger = this.handleTrigger.bind(this)
    this.handleClose = this.handleClose.bind(this)

    this.externalEls.trigger.elements.forEach((triggerEl) => {
      this.listeners.add(triggerEl, 'click', this.handleTrigger)
    })
    this.listeners.add(this, 'click', this.handleClose)

    this.listeners.add(document.documentElement, 'keydown', (e) => {
      if (e.key === 'Escape') {
        this.handleClose()
      }
    })

    if (this.els.slide.elements.length < 2) return

    this.carousel = this.setupCarousel()
  }

  handleTrigger (event) {
    const triggerEl = event.target

    if (!triggerEl) return

    document.body.classList.add('util-SiteOverflowed')
    this.showModal()

    if (!this.carousel) return

    this.carousel.moveToIdx(parseInt(triggerEl.dataset.slideIndex))
  }

  handleClose (event) {
    const triggerEl = event.target.closest('[data-product-modal-el="close"]')

    if (!triggerEl) return

    document.body.classList.remove('util-SiteOverflowed')
    this.close()
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: true,
        mode: 'snap',
        vertical: true,
        slides: {
          origin: 'center',
          perView: 1.3,
          spacing: 0,
        },
        breakpoints: {
          '(min-width: 901px)': {
            vertical: false,
            slides: {
              origin: 'center',
              perView: 1.8,
              spacing: 0,
            },
          },
        },
        detailsChanged: (instance) => {
          const slideEls = this.querySelectorAll(
            '[data-product-modal-el="slide"]',
          )

          slideEls.forEach((slideEl, index) => {
            const matchingSlide = instance.track.details.slides[index]

            const slidePortion = matchingSlide.portion

            const rotatePosNeg = matchingSlide.distance < 0 ? '-' : ''

            const rotateLimit = window.BAO.MediaBreakpoints.isLg ? 25 : 15
            const rotateAmount = rotateLimit - rotateLimit * slidePortion

            const translateYLimit = window.BAO.MediaBreakpoints.isLg ? 25 : 10
            const translateYAmount =
              translateYLimit - translateYLimit * slidePortion

            const opacityLimit = 0.3
            const opacityAmount = opacityLimit - opacityLimit * slidePortion

            slideEl.style.setProperty(
              '--Slide_Transform',
              `rotate(${rotatePosNeg}${rotateAmount}deg) translateY(${translateYAmount}%)`,
            )

            slideEl.style.setProperty('--Slide_Opacity', opacityAmount)

            slideEl.classList.toggle(
              'prd-Modal_Slide-active',
              instance.track.details.abs === matchingSlide.abs,
            )

            slideEl.inert = instance.track.details.abs !== matchingSlide.abs
          })
        },
      },
      [
        setInitialised(),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
      ],
    )
  }
}

customElements.define('product-modal', ProductModal, { extends: 'dialog' })
